// Redux-form encapsulated form component
import PropTypes from "prop-types";
import React from "react";
import RenderField from "cxa-components/field";
import { Field } from "redux-form";
import { intlShape, injectIntl } from "react-intl";

const FormField = ({ name, component, children, description, hideError = false, ...props }) => {
  return (
    <Field
      id={name}
      name={name}
      field={component}
      component={RenderField}
      description={description}
      hideError={hideError}
      {...props}
    >
      {children}
    </Field>
  );
};

FormField.propTypes = {
  component: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  description: PropTypes.string,
  hideError: PropTypes.bool,
  intl: intlShape.isRequired,
};

FormField.displayName = "FormField";

export default injectIntl(FormField);



// WEBPACK FOOTER //
// ./components/common/form-field/FormField.js